import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GeoFilterState {
  selectedGeo: string[];
}
const savedGeo = JSON.parse(localStorage.getItem("geoFilter") || "[]");

const initialState: GeoFilterState = {
  selectedGeo: savedGeo,
};

export const geoFilterSlice = createSlice({
  name: "geoFilter",
  initialState,
  reducers: {
    setGeoFilter(state, action: PayloadAction<string[]>) {
      state.selectedGeo = action.payload;
      localStorage.setItem("geoFilter", JSON.stringify(state.selectedGeo));
    },
    addGeo(state, action: PayloadAction<string>) {
      if (!state.selectedGeo.includes(action.payload)) {
        state.selectedGeo.push(action.payload);
        localStorage.setItem("geoFilter", JSON.stringify(state.selectedGeo));
      }
    },
    removeGeo(state, action: PayloadAction<string>) {
      state.selectedGeo = state.selectedGeo.filter(
        (geo) => geo !== action.payload
      );
      localStorage.setItem("geoFilter", JSON.stringify(state.selectedGeo));
    },
    clearGeoFilter(state) {
      state.selectedGeo = [];
      localStorage.removeItem("geoFilter");
    },
  },
});

export const { setGeoFilter, addGeo, removeGeo, clearGeoFilter } =
  geoFilterSlice.actions;

export default geoFilterSlice.reducer;
